/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export const ACTIVITIES_EVENTS_FILTER_VALUE_ADD = "ACTIVITIES_EVENTS_FILTER_VALUE_ADD";
export const ACTIVITIES_EVENTS_FILTER_VALUE_REMOVE = "ACTIVITIES_EVENTS_FILTER_VALUE_REMOVE";
export const ACTIVITIES_EVENTS_FILTER_VALUE_BULK_REMOVE =
  "ACTIVITIES_EVENTS_FILTER_VALUE_BULK_REMOVE";
export const ACTIVITIES_EVENTS_FILTER_VALUE_RESET = "ACTIVITIES_EVENTS_FILTER_VALUE_RESET";

export const UPDATE_ACTIVITIES_EVENTS_CURRENT_PAGE = "UPDATE_ACTIVITIES_EVENTS_CURRENT_PAGE";
export const UPDATE_ACTIVITIES_EVENTS_PAGE_SIZE = "UPDATE_ACTIVITIES_EVENTS_PAGE_SIZE";

export const GET_USER_PROFILE_BY_SELECTED_APPLICATION_ID =
  "GET_USER_PROFILE_BY_SELECTED_APPLICATION_ID";
export const GET_USER_PROFILE_BY_SELECTED_APPLICATION_ID_SUCCESS =
  "GET_USER_PROFILE_BY_SELECTED_APPLICATION_ID_SUCCESS";
export const GET_USER_PROFILE_BY_SELECTED_APPLICATION_ID_FAIL =
  "GET_USER_PROFILE_BY_SELECTED_APPLICATION_ID_FAIL";

export const GET_APPLICATION_FLAGS_BY_SELECTED_APPLICATION_ID =
  "GET_APPLICATION_FLAGS_BY_SELECTED_APPLICATION_ID";
export const GET_APPLICATION_FLAGS_BY_SELECTED_APPLICATION_ID_FAIL =
  "GET_APPLICATION_FLAGS_BY_SELECTED_APPLICATION_ID_FAIL";
export const GET_APPLICATION_FLAGS_BY_SELECTED_APPLICATION_ID_SUCCESS =
  "GET_APPLICATION_FLAGS_BY_SELECTED_APPLICATION_ID_SUCCESS";

export const GET_APPLICATION_QUESTIONS_BY_SELECTED_APPLICATION_ID =
  "GET_APPLICATION_QUESTIONS_BY_SELECTED_APPLICATION_ID";
export const GET_APPLICATION_QUESTIONS_BY_SELECTED_APPLICATION_ID_SUCCESS =
  "GET_APPLICATION_QUESTIONS_BY_SELECTED_APPLICATION_ID_SUCCESS";
export const GET_APPLICATION_QUESTIONS_BY_SELECTED_APPLICATION_ID_FAIL =
  "GET_APPLICATION_QUESTIONS_BY_SELECTED_APPLICATION_ID_FAIL";

export const GET_HIGHLIGHTED_ACTIVITIES_EVENTS_BY_SELECTED_APPLICATION_ID =
  "GET_HIGHLIGHTED_ACTIVITIES_EVENTS_BY_SELECTED_APPLICATION_ID";
export const GET_HIGHLIGHTED_ACTIVITIES_EVENTS_BY_SELECTED_APPLICATION_ID_SUCCESS =
  "GET_HIGHLIGHTED_ACTIVITIES_EVENTS_BY_SELECTED_APPLICATION_ID_SUCCESS";
export const GET_HIGHLIGHTED_ACTIVITIES_EVENTS_BY_SELECTED_APPLICATION_ID_FAIL =
  "GET_HIGHLIGHTED_ACTIVITIES_EVENTS_BY_SELECTED_APPLICATION_ID_FAIL";

export const GET_ADDITIONAL_ACTIVITIES_EVENTS_BY_SELECTED_USERPROFILE_ID =
  "GET_ADDITIONAL_ACTIVITIES_EVENTS_BY_SELECTED_USERPROFILE_ID";
export const GET_ADDITIONAL_ACTIVITIES_EVENTS_BY_SELECTED_USERPROFILE_ID_SUCCESS =
  "GET_ADDITIONAL_ACTIVITIES_EVENTS_BY_SELECTED_USERPROFILE_ID_SUCCESS";
export const GET_ADDITIONAL_ACTIVITIES_EVENTS_BY_SELECTED_USERPROFILE_ID_FAIL =
  "GET_ADDITIONAL_ACTIVITIES_EVENTS_BY_SELECTED_USERPROFILE_ID_FAIL";

export const GET_ACTIVITY_EVENT_BY_ID = "GET_ACTIVITY_EVENT_BY_ID";
export const GET_ACTIVITY_EVENT_BY_ID_SUCCESS = "GET_ACTIVITY_EVENT_BY_ID_SUCCESS";
export const GET_ACTIVITY_EVENT_BY_ID_FAIL = "GET_ACTIVITY_EVENT_BY_ID_FAIL";

export const CLEAR_APPLICATION_DETAILS_STATE = "CLEAR_APPLICATION_DETAILS_STATE";

export const UPDATE_APPLICATION_STATUSES_AND_REMOVE_FLAGS =
  "UPDATE_APPLICATION_STATUSES_AND_REMOVE_FLAGS";
export const UPDATE_APPLICATION_STATUSES_AND_REMOVE_FLAGS_FAIL =
  "UPDATE_APPLICATION_STATUSES_AND_REMOVE_FLAGS_FAIL";
export const UPDATE_APPLICATION_STATUSES_AND_REMOVE_FLAGS_SUCCESS =
  "UPDATE_APPLICATION_STATUSES_AND_REMOVE_FLAGS_SUCCESS";
export const UPDATE_APPLICATION_STATUSES_AND_REMOVE_FLAGS_RESET =
  "UPDATE_APPLICATION_STATUSES_AND_REMOVE_FLAGS_RESET";

export const UPDATE_APPLICATION_TECHNOLOGY_AREA_AND_RESET_SCORES =
  "UPDATE_APPLICATION_TECHNOLOGY_AREA_AND_RESET_SCORES";
export const UPDATE_APPLICATION_TECHNOLOGY_AREA_AND_RESET_SCORES_FAIL =
  "UPDATE_APPLICATION_TECHNOLOGY_AREA_AND_RESET_SCORES_FAIL";
export const UPDATE_APPLICATION_TECHNOLOGY_AREA_AND_RESET_SCORES_SUCCESS =
  "UPDATE_APPLICATION_TECHNOLOGY_AREA_AND_RESET_SCORES_SUCCESS";
export const UPDATE_APPLICATION_TECHNOLOGY_AREA_AND_RESET_SCORES_RESET =
  "UPDATE_APPLICATION_TECHNOLOGY_AREA_AND_RESET_SCORES_RESET";
